import { GridColumn } from 'src/components/GridWrapper';

const percentRecQtyColumns: GridColumn<any>[] = [
  {
    field: 'poQty',
    title: 'PO Qty',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip: 'quantity of items approved on the PO',
  },
  {
    field: 'receivingQty',
    title: 'Total Qty Received',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip: 'quantity of items received on both in progress and completed receipts',
  },
  {
    field: 'receiptVariance',
    title: 'Receipt Variance',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip:
      'difference between item quantity ordered on PO vs all items on both in progress and completed receipts',
  },
  {
    field: 'currentDocQty',
    title: 'Current Doc Qty',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip: 'quantity of items recorded on the current doc',
  },
  {
    field: 'totalDocQty',
    title: 'Total Doc Qty',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip:
      'quantity of items on all in progress and completed docs associated with this PO (including current doc)',
  },
  {
    field: 'docVariance',
    title: 'Doc Variance',
    width: '150px',
    dataType: 'number',
    menu: false,
    headerCellTooltip:
      'difference between item quantity ordered on PO vs all item quantities on both in progress and completed docs for this PO',
  },
];

export default percentRecQtyColumns;
